import { Environment } from '../types/config';
import packageJson from '../../package.json';

let environment: Environment = 'PRO';
if (window.runtimeConfig.apiEnv.environment === 'PRE') {
    environment = 'PRE';
} else if (
    window.runtimeConfig.apiEnv.environment === 'DEV' ||
    import.meta.env.DEV
) {
    environment = 'DEV';
}

export function getPlayBaseUrl(env: Environment): string {
    return env === 'PRO'
        ? 'https://play.sporttia.com'
        : 'https://preplay.sporttia.com';
}

const generalConfig = {
    environment,
    version: packageJson.projectVersion,
    translationConfKey: 'appSC',
    // Mismos idiomas, mismos rótulos y mismos códigos de bandera que
    // sporttia-competitions, para que el selector se vea igual en las dos.
    // `flag` es el código de flag-icons (clase `fi fi-{flag}`).
    languages: [
        {
            key: 'es',
            caption: 'Español',
            flag: 'es',
        },
        {
            key: 'en',
            caption: 'English',
            flag: 'gb',
        },
        {
            key: 'cl',
            caption: 'Chileno',
            flag: 'cl',
        },
        {
            key: 'ca',
            caption: 'Català',
            flag: 'es-ct',
        },
        {
            key: 'gl',
            caption: 'Galego',
            flag: 'es-ga',
        },
        {
            key: 'de',
            caption: 'Deutsch',
            flag: 'de',
        },
        {
            key: 'fr',
            caption: 'Français',
            flag: 'fr',
        },
        {
            key: 'pt',
            caption: 'Português',
            flag: 'pt',
        },
    ],
    sessionTimeout: {
        // Valor por defecto activado. Cambiar la env para activar o desactivar la desconexión automática después de un tiempo de inactividad.
        isEnabled:
            import.meta.env.VITE_LOGOUT_TIMEOUT_ENABLED === 'true' ||
            import.meta.env.VITE_LOGOUT_TIMEOUT_ENABLED === undefined,
        timeoutMs: 300000,
    },
    testStripeTerminal: {
        // Activar para hacer pruebas con Stripe terminal sin una tarjeta real.
        isEnabled: import.meta.env.VITE_TEST_STRIPE_TERMINAL === 'true',
        // Código de la tarjetas de prueba dada por Stripe.
        testCard: import.meta.env.VITE_POS_STRIPE_SIMULATED_TEST_CARD,
    },
} as const;

export default generalConfig;
